/**
 * Video Vue Component
 * ------------------------------------------------------------------------------
 *
 */

export default {
  data () {
    return {
      showPlayButton: true
    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    toggleVideo () {
      if (this.$refs.videoComponent.paused) {
        this.$refs.videoComponent.play()
        this.showPlayButton = false
      } else {
        this.$refs.videoComponent.pause()
        this.showPlayButton = true
      }
    }
  }
}
